var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#00b0ba",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-user-round-cog",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21a8 8 0 0 1 10.434-7.62"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5 14.3-.4.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.9 20.8-.4.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.7 19.5-.9-.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15.2 16.9-.9-.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m21.7 16.5-.9.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.2 19.1-.9.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5 21.7-.4-.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16.9 15.2-.4-.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/admin-logo.d380bb4fe1102f610b326e3b37ef08f9.svg";
export { ForwardRef as ReactComponent };